export function toggleScrollState(shouldAllowScroll: boolean): void {
  const targetSelector =
    document.querySelector('mat-dialog-container') !== null
      ? 'mat-dialog-content'
      : 'mat-sidenav-content';

  const el = document.querySelector(targetSelector);

  if (!el) {
    return;
  }

  if (shouldAllowScroll) {
    el.classList.remove('overflow-hidden', 'w-100');
  } else {
    el.classList.add('overflow-hidden', 'w-100');
  }
}
